var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"3"}},[_c('login-form',{attrs:{"navigeerUrl":_vm.getNavigatieURL}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }